import { actionKitImpFunction } from '../../../../../../components/ozmoit/common';

import {
  PaginationQueryDto,
  PaginationRequestType,
} from '../../../../../../types/paginationRequestType';

import {
  getCoursesWithSectionsFormData,
  getOfferCoursesWithSections,
} from '../api';
import { CourseWithSection } from '../types';

interface CoursesSectionsParams {
  ceAcademicOfferId: number;
}

const getCoursesWithSectionsFormDataAction = actionKitImpFunction(
  async (ceAcademicOfferId: number) => {
    const response = await getCoursesWithSectionsFormData(ceAcademicOfferId);

    if (response.error) {
      throw new Error(
        response.error.error.message || 'Error loading form data',
      );
    }

    return response.data;
  },
);

const getCoursesWithSectionsAction = actionKitImpFunction(
  async ({
    page,
    ...params
  }: PaginationQueryDto<CoursesSectionsParams>): Promise<
    PaginationRequestType<CourseWithSection>
  > => {
    const response = await getOfferCoursesWithSections({
      ...params,
      page: Math.max(page - 1, 0),
    });
    if (response.error) {
      throw new Error('Error fetching ce offer section list');
    }

    return response.data;
  },
);

export { getCoursesWithSectionsAction, getCoursesWithSectionsFormDataAction };
